import React from "react";
import * as hrmsService from "../../../services/hrmsService";
import { FormDrawer } from "../hrForm";
import { formatDate } from "../hrUi";

const KINDS = [
  { label: "I forgot to punch (missing punch)", value: "MISSING_PUNCH" },
  { label: "My punch is wrong", value: "WRONG_PUNCH" },
  { label: "I was on duty outside the office", value: "ON_DUTY" },
  { label: "I worked from home", value: "WFH" },
];

// The fields depend on the kind: times only make sense for a punch correction.
export const correctionFields = (values) => [
  { key: "kind", label: "What happened", type: "select", required: true, options: KINDS },
  ...(values.kind === "MISSING_PUNCH" || values.kind === "WRONG_PUNCH"
    ? [
        { key: "in_time", label: "Came in at", type: "time", hint: values.kind === "WRONG_PUNCH" ? "Both times are needed; they replace the punches recorded for the day." : "Give the time you came in, the time you left, or both." },
        { key: "out_time", label: "Left at", type: "time" },
      ]
    : []),
  { key: "reason", label: "Reason", type: "textarea", required: true, max: 500, rows: 3 },
];

// ATT-05 / ATT-06: ask for a day to be corrected. It goes to your approver; nothing changes until it is approved.
export default function CorrectionDrawer({ date, onHide, onDone }) {
  return (
    <FormDrawer
      show={!!date}
      title={date ? `Correct ${formatDate(date)}` : "Correct a day"}
      initial={{ kind: "MISSING_PUNCH" }}
      fields={correctionFields}
      onHide={onHide}
      onDone={onDone}
      onSave={(clean) => hrmsService.requestCorrection({ ...clean, att_date: date })}
      submitLabel="Send for approval"
    />
  );
}
